import { post, postJson, get, deleteApi, putJson, put } from "./axios";

const RESOURCE_BASE_PATH = "/autoMarkConfig";

//自动化打标

// 查询自动化标签
export const getBuyerByLabelName = (p) => get(`${RESOURCE_BASE_PATH}/list`, p);

//删除自动化标签
export const deleteBuyerById = (id) => deleteApi(`${RESOURCE_BASE_PATH}/${id}`);

// 修改自动化打标签规则
export const modificationImplementationRule = (p) => put(`${RESOURCE_BASE_PATH}/`, p);

//  插入自动化打标签
export const insertImplementation = (p) => postJson(`${RESOURCE_BASE_PATH}/insert`, p);

// 修改自动化打标签开关
export const modificationImplementationSwith = (p) => put(`${RESOURCE_BASE_PATH}/switch`, p);